<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedCompanies"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Company')"
      :list="companyOptions"
      :placeholder="$t('All companies')"
      max-labels-visible="5"
      can-deselect
      labels-primary
      :loading="loading"
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { $t } from '@/composables/translation'
import { graphql } from '@/gql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedCompanies: ModelRef<{ label: string; value: string }[]> = defineModel({
  default: () => [],
})

const { result, loading } = useQuery(
  graphql(`
    query FreelancerClientCompanies($id: ID!) {
      worker(id: $id) {
        id
        clients {
          id
          company {
            id
            name
          }
        }
      }
    }
  `),
  () => ({
    id: currentAccount.globalId,
  }),
  {
    clientId: 'publicApi',
  },
)

const companyOptions = computed(
  () =>
    result.value?.worker?.clients?.map((client) => ({
      label: client.company.name,
      value: client.company.id,
    })) ?? [],
)
</script>
